import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import dotenv from 'react-dotenv';
import { useDispatch, useSelector } from 'react-redux';
import { getIAAM } from '../../../reducer/iaamSlice';
import { getWeekOfYear } from '../../../reducer/weekOfYearSlice';

import { setCOChecked, setCOValue } from '../../../reducer/LarvaIndexSlice';
import { getDengueSetting, setDengueCo } from '../../../reducer/dengueSettingSlice';

function HISetting(props) {
    const dispatch = useDispatch();
    const { co } = useSelector(getDengueSetting);
    const iaam = useSelector(getIAAM);
    const woy = useSelector(getWeekOfYear);
    const [checked, setChecked] = useState(false);
    

    useEffect(() => {
        const getAPI = async () => {
            let access_token = await iaam.getAccessToken();
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json', 
                    'Authorization': `bearer ${access_token}`
                }
            }

            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/report/larval_survey_place_report?co=true&start_date=${woy.start.from}&end_date=${woy.end.to}`, options);
            const resData = await res.json();
            let tmpData = [];
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];
                let color = "#D92405";
                let zIndex = 99;
                let value = parseFloat(element.hi);
                if (value === 0) {
                    color = "#41A30D";
                    zIndex = 96;
                } else if (value <= 10) {
                    color = "#FFCE38";
                    zIndex = 97;
                } else if (value <= 50) {
                    color = "#EF6A23";
                    zIndex = 98;
                }
                let data = {
                    ...element,
                    color: color,
                    zIndex: zIndex,
                    imageSrc: 'home.png'
                }
                tmpData.push(data);
            }
            dispatch(setCOValue(tmpData));
        }
        if (iaam) {
            if (checked) {
                // dispatch(setCluster({}));
                dispatch(setCOValue([]));
                dispatch(setCOChecked(true));
                getAPI();   
            } else {
                dispatch(setCOValue([]));
                dispatch(setCOChecked(false));
                // dispatch(setCluster({}));
            }
        }
    }, [checked, iaam, woy, dispatch])

    useEffect(() => {
        setChecked(co);
    }, [co])

    return (
        <>
            <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
                dispatch(setDengueCo(event.target.checked));
                // setChecked(event.target.checked);
            }}/>} label="ดัชนีทางกีฏวิทยาในหมู่บ้าน/ชุมชน" />
        </>
    )
}

export default HISetting;